import { publicEnv } from "../../app/env";
import type { BillboardApi } from "./BillboardApi";
import { MockBillboardApi } from "./MockBillboardApi";
import { NetlifyBillboardApi } from "./NetlifyBillboardApi";

export type BillboardApiMode = "mock" | "netlify";

export function createBillboardApi(): {
  api: BillboardApi;
  mode: BillboardApiMode;
} {
  if (
    publicEnv.VITE_REALTIME_MODE === "mock" &&
    publicEnv.VITE_APP_ENV !== "production"
  ) {
    return { api: new MockBillboardApi(), mode: "mock" };
  }
  return { api: new NetlifyBillboardApi(), mode: "netlify" };
}
